<template>
    <div class="qr-code-list-main col-xs-12">
        <div class="row">
            <template v-if="gridImageArr && gridImageArr.length > 0">
                <template v-for="(grid, index) in gridImageArr">
                    <template v-for="(gridImg, indexImg) in grid">
                        <template v-if="gridImg.vin_no">
                            <div :key="index + indexImg" class="qr-code-detail col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                <p class="qr-code-label hide-label vin-no">VIN: {{gridImg.vin_no}}</p>
                                <img :src="gridImg.doc" alt="QR code">
                                <!-- <p class="qr-code-label hide-label"> {{grid.vin_no}} </p> -->
                                <p class="qr-code-label hide-label"> For more information on this unit, scan code with your smartphone </p>
                            </div>
                        </template>
                        <template v-else>
                            <div :key="index + indexImg" class="qr-code-detail col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                <p class="qr-code-label hide-label vin-no">&nbsp;</p>
                                <img src="/static/images/300.png">
                                <p class="qr-code-label hide-label blank-label-text"> For more information on this unit, scan code with your smartphone </p>
                            </div>
                        </template>
                    </template>
                </template>
            </template>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    import moment from 'moment';
    import timezone from 'moment-timezone';
    import EventBus from "../../components/event-bus";
    var self;

    export default {
        name: 'GenerateQRCode',
        components: {
        },
        mixins: [commonMixins],
        data() {
            return {
                gridImageArr: [],
                session: '',
            }
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.session = this.$route.params.session;
            self.getRole();
            self.getGridQRCodeImages();
        },
        methods: {
            getGridQRCodeImages: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
                };
                var fields = {
                    session: self.session,
                    pages: localStorage.getItem("pages"),
                };
                self.showLoader();
                HTTP.post("gridqrcodeimages", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.gridImageArr = response.data.content;
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            }
        }
    }
</script>
<style scoped>
    .qr-code-list-main {
        float: left;
        width: 100%;
    }
    .qr-code-detail {
        float: left;
    }
    .qr-code-detail { 
        float: left;
    }
    .qr-code-detail img {
        width: 100%;
        height: 252px;
        border: 1px solid #dddddd;
        object-fit: contain;
        background: white;
    }
    .qr-code-label {
        background-color: #098de1;
        width: 100%;
        font-size: 15px;
        line-height: 20px;
        padding: 12px 15px;
        text-align: center;
        color: #ffffff;
        font-family: 'SanFranciscoDisplayMedium';
        text-transform: uppercase;
        -webkit-print-color-adjust: exact !important
    }
    /* .hide-label {
        display: none;
    } */
    .qr-code-label.vin-no {
        margin: 0px;
        font-weight: bold;
    }
    .blank-label-text {
        color: #098de1;
    }
    @page{
        size: auto;
        margin: 22.225mm 30.1625mm 22.225mm 30.1625mm;  
    }
    .row {
        margin-right: 0px;
        margin-left: 0px;
        float: left;
        width: 100%;
        display: inherit;
    }
    @media print {
        body {
            background: #fff;
        }
        .row {
            margin-right: 0px;
            margin-left: 0px;
            float: left;
            width: 100%;
            display: inherit;
            background: #fff;
        }
        .qr-code-label {
            /* background-color: #098de1;
            -webkit-print-color-adjust: exact !important; */
            background-color: #fff;
            color: #000;
            /* margin-bottom: 38px; */
            margin-bottom: 28px;
            font-size: 30px;
            line-height: 34px;
        }
        .qr-code-label.vin-no {
            margin: 0px;
            font-weight: bold;
        }
        @page{
            margin: 22.225mm 30.1625mm 22.225mm 30.1625mm;  
        }
        .qr-code-detail {
            float: left;
            width: 50%;
            max-width: 50%;
            /* padding: 0px; */
            /* border: 1px solid #000; */
        }
        .qr-code-detail img {
            /* height: 278px; */
            height: 294px;
            border: none;
            background: #fff;
        }
        .blank-label-text {
            color: #fff;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/QRCode/GridQRCodeImages.vue